import React,{ useState,useEffect,useContext } from 'react';
import axios from 'axios'
import './Shop.css'
import TitleCaptionDescription from '../pages/TitleCaptionDescription';
import Countdown from 'react-countdown-now';
import AuthContext from './Contexts/AuthContext';
import CartContext from './Contexts/CartContext';
import LoadingContext from './Contexts/LoadingContext';
import ShopItemPs from './placeholders/shopItemPs';
import settings from '../../settings.json'
import ImageAspectRatio from './utils/ImageAspectRatio';
import MySlider from '../MySlider';
import { SpinnerCustom } from '../MainComponents/Spinner';

function Shopdetails(props) {
    const contextAuth = useContext(AuthContext)
    const contextCart = useContext(CartContext)
    const contextLoading = useContext(LoadingContext)
    const [item, setItem] = useState(undefined)
    const [loading, setLoading] = useState(true)
    const [variazione,setVariazione] = useState(undefined)
    const [quantity,setQuantity] = useState(1)
    const [size, setSize] = useState("")
    const [listOfSizes, setListOfSizes] = useState(undefined)
    const [linkToSize, setLinkToSize] = useState(undefined)
    const [labelSizes, setLabelSizes] = useState(undefined)
    const [addtobuttonloading, setAddtobuttonloading] = useState(false)
    const [message, setMessage] = useState(null)
    
    function changevariazione(e){
        setVariazione(item.variation_set.filter((vari)=>{
            return vari.id.toString()===e.target.value
        })[0])
    }

    function addToChart(){
        if(contextAuth.AuthState.token){
            setAddtobuttonloading(true)
            let data ={quantity,size,variazione}
            const header = { 'headers': { 'Authorization': 'Token '+contextAuth.AuthState.token }}
            axios.post(settings.url_api+'/api/carts/', data,header).then((res)=>{
                contextCart.CartDispatch({type:"INIT",payload:res.data})
                setAddtobuttonloading(false)
            }).catch((err)=>{
                console.log("errore, riprova")
                setAddtobuttonloading(false)
            })
        }else{
            setMessage("Effettua prima il login")
            setTimeout(() => {
               setMessage(null)
            }, 5000);
        }
    }

    function getBestVariazione(listOfVariazioni){
        let price = null;
        listOfVariazioni.forEach(vari => {
            let tmp_price = 0
            if(vari.sale_price !== null && vari.validity_for !== null && new Date(vari.validity_for).getTime() > new Date().getTime()){
                tmp_price = vari.price - (vari.price * (vari.sale_price / 100));
            }else if(vari.sale_price !== null && vari.validity_for === null){
                tmp_price = vari.price - (vari.price * (vari.sale_price / 100));
            }else{
                tmp_price = vari.price;
            }
            if(price == null){
                price = tmp_price
                setVariazione(vari)
            }else if(tmp_price < price){
                price = tmp_price
                setVariazione(vari)
            }
        })
    }

    useEffect(() => {
        if(props.location.product){
            setItem(props.location.product)
            getBestVariazione(props.location.product.variation_set)
            setLoading(false)
        }else{
            contextLoading.LoadingDispatch({type:"ADD_TO_LOADING",payload:90})
            axios.get(settings.url_api+'/api/products/'+props.match.params["id_prodotto"]+"/").then((res)=>{
                setItem(res.data)
                getBestVariazione(res.data.variation_set)
                setLoading(false)
                contextLoading.LoadingDispatch({type:"ADD_TO_LOADING",payload:100})
                contextLoading.LoadingDispatch({type:"COMPLETE",payload:50})
            })
        }
    }, [])
    useEffect(() => {
        if(variazione && variazione.sizes){
            if(variazione.sizes.list_sizes && JSON.parse(variazione.sizes.list_sizes).length>0){
                setListOfSizes(JSON.parse(variazione.sizes.list_sizes))
                setSize(JSON.parse(variazione.sizes.list_sizes)[0])
                setLinkToSize(variazione.sizes.link_to_size)
                setLabelSizes(variazione.sizes.label_sizes)
            }
        }else{
            setListOfSizes(undefined)
        }
    }, [variazione])
    return (
        <div className="row">
            {loading ? <ShopItemPs/>:
            <>
            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12 shop-slider" >
                {variazione && variazione.variationimage_set ?
                    <MySlider immagini={variazione.variationimage_set} aspectratio={"4:3"}></MySlider>
                    :null
                }
                <div className="description-item d-none d-sm-block">
                    <div className="shop-title">DESCRIZIONE*</div>
                    <div dangerouslySetInnerHTML={{__html: item["description"]}} />
                </div>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12" style={{textAlign:"left"}}>
                <div style={{paddingBottom:"10px"}}>
                    <TitleCaptionDescription size={"25px"} title={item["title"].toUpperCase()}/>
                </div>
                <div>
                    <div className="shop-detail-subtitle" dangerouslySetInnerHTML={{ __html: variazione.subtitle}}/>
                    <div className="shop-detail-other-info" dangerouslySetInnerHTML={{ __html: variazione.other_info}}/>
                </div>
                {item.variation_set.length > 1 ?
                    <div className="shop-variazioni">
                        {item.variation_set.map((variazion,i)=>{
                            return(
                            <div key={i}>
                                <label className="control control-radio">
                                    <input type="radio" value={variazion.id} checked={variazion===variazione} onChange={(e)=>changevariazione(e)}/>
                                    {variazion.title}
                                    <div className="control_indicator"></div>
                                </label>
                            </div>
                            )
                        })}
                    </div>
                 :null}

                <div>
                    {listOfSizes && listOfSizes.length>1 ? 
                    <div className="shop-taglie-label">
                        {labelSizes ? <b>{labelSizes}:</b>  : null }
                        <select name="size" value={size} id="size" onChange={(e)=>setSize(e.target.value)}>
                        {listOfSizes.map((taglia,i)=>{
                            return(
                                <option key={i} value={taglia}>{taglia}</option>
                            )
                        })}
                        </select>
                        {linkToSize ? 
                        <a href={linkToSize} target="_blank">
                            <div style={{fontSize:"14px",textDecoration:"underline",paddingBottom:"10px"}}>
                                Come scegliere?
                            </div> 
                        </a> : null }
                    </div>
                    :listOfSizes && listOfSizes.length === 1 ? 
                        <div className="shop-taglie-label"><b>{listOfSizes[0]}</b></div>
                    :null}

                    {(variazione.inventory === null || variazione.inventory > 0) && !variazione.isUnique ?
                    <div className="shop-quantita-label" style={{textAlign:"center"}}>
                        <b>QUANTITA</b> 
                        <input style={{marginLeft:"10px"}} type="number" min="1" value={quantity} max={variazione.inventory}onChange={(e)=>setQuantity(e.target.value)} />
                        {variazione.inventory && variazione.inventory > 0 ? 
                            <div>
                                <span><small>Solo {variazione.inventory} rimanenti</small></span>
                            </div> 
                        : null}
                    </div>
                    :null}
                    {variazione.isUnique ? 
                        <span>PEZZO UNICO</span>       
                    :null}
                    <div className="shop-quantita-prezzo">
                        {variazione.sale_price !== null && variazione.validity_for !== null && new Date(variazione.validity_for).getTime() > new Date().getTime() ? 
                        <div style={{textAlign:"center",fontSize:"25px"}}>
                            <span style={{textDecoration: "line-through",fontSize:"20px"}}>{variazione.price}€</span> - <b>{variazione.price - (variazione.price * (variazione.sale_price / 100))}€</b>
                            {variazione.inventory === null || variazione.inventory > 0 ?
                                <div style={{fontSize:"14px"}}>
                                    <Countdown daysInHours={false} date={new Date(variazione.validity_for).getTime()}/>s</div>
                            :null}
                        </div>
                        :
                        variazione.sale_price !== null && variazione.validity_for === null ? 
                        <div style={{textAlign:"center",fontSize:"25px"}}>
                            <span style={{textDecoration: "line-through",fontSize:"20px"}}>{variazione.price}€</span> - <b>{variazione.price - (variazione.price * (variazione.sale_price / 100))}€</b>
                        </div>
                        :
                        <div style={{textAlign:"center",fontSize:"25px"}}>
                            {/* <b>{variazione.price - (variazione.price * (variazione.sale_price / 100))}€**</b> */}
                            <b>{variazione.price} €</b>
                        </div>    
                    }
                    </div>
                    {variazione.inventory === null || variazione.inventory > 0 ? 
                        <div className="selectbutton shop-buttons" style={{textAlign:"center"}}>
                            { !addtobuttonloading ? 
                                <button className="button-resume-sm" onClick={()=>{addToChart()}}> AGGIUNGI AL CARRELLO </button>
                                :
                                <SpinnerCustom height={50} width={50} />
                                }
                            {/* <span className="button-addlist">AGGIUNGI ALLA LISTA DESIDERI</span> */}
                            <div className={message ? "show-message message" : "message"}>
                               {message}
                            </div>
                        </div>:
                        <div style={{textAlign:"center"}}>
                            Il prodotto non è più disponibile clicca <span className="shop-aggiornamentoprodotto" onClick={()=>{console.log("fare il clicca qui con messaggio")}}>qui</span> per sapere quando sarà nuovamente disponibile
                        </div>}
                    <div className="description-item d-block d-sm-none">
                        <div className="shop-title">DESCRIZIONE*</div>
                        <div dangerouslySetInnerHTML={{__html: item["description"]}} />
                    </div>
                </div>
            </div>
            </>}
        </div>
    );
}

export default Shopdetails;